/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface RawDataDto {
  adapterId?: number;
  adapterSerial?: string;
  altitude?: number;
  beaconData?: string;
  bearing?: number;
  canData?: string;
  ddiCanValuesConfig?: string;
  ddiCanValuesDevices?: string;
  ddiCanValuesPayload?: string;
  driverId?: number;
  driverUsername?: string;
  fieldId?: number;
  formatType?: string;
  gpsQuality?: number;
  id?: number;
  jobTimeId?: number;
  latitude?: number;
  linAccM?: number;
  linAccX?: number;
  linAccXmax?: number;
  linAccXmin?: number;
  linAccY?: number;
  linAccYmax?: number;
  linAccYmin?: number;
  linAccZ?: number;
  linAccZmax?: number;
  linAccZmin?: number;
  locationId?: number;
  longitude?: number;
  machineId?: number;
  machineMake?: string;
  ownerUsername?: string;
  primaryImplementId?: number;
  resource?: string;
  secondaryImplementId?: number;
  speed?: number;
  telemetryData?: string;
  time?: number;
  xtrCanValuesConfig?: string;
  xtrCanValuesPayload?: string;
}
